import { data } from '../../svg/Keep/data';
import { makeIcon } from '../makeIcon';

export const Keep = makeIcon(data, 'keep', 'Keep');

export default Keep;
